import { initializeApp } from 'firebase/app';
import { getAuth, setPersistence, browserLocalPersistence } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';
import { getStorage } from 'firebase/storage';
import { getFunctions } from 'firebase/functions';

// Note: Firebase web API keys are public identifiers by design — they identify
// the Firebase project to the Google SDK, not secret credentials. Security is
// enforced by Firestore Security Rules and Firebase Auth, not the API key.
// See: https://firebase.google.com/docs/projects/api-keys#api-keys-web-apps
// Values are injected at build time from .env.production / .env.staging (git-ignored).
const firebaseConfig = {
  apiKey: process.env.VITE_FIREBASE_API_KEY,
  authDomain: process.env.VITE_FIREBASE_AUTH_DOMAIN,
  projectId: process.env.VITE_FIREBASE_PROJECT_ID,
  storageBucket: process.env.VITE_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.VITE_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.VITE_FIREBASE_APP_ID,
};

let app;
let auth: any;
let db: any;
let storage: any;
let functions: any;

try {
  if (!firebaseConfig.apiKey) {
    throw new Error("Firebase API Key is missing. Check your .env file.");
  }
  app = initializeApp(firebaseConfig);
  auth = getAuth(app);
  
  // Force local persistence synchronously to prevent session loss on Mac redirects
  setPersistence(auth, browserLocalPersistence).catch((err) => {
    console.error("MarginPro: Failed to set persistence:", err);
  });

  db = getFirestore(app);
  storage = getStorage(app);
  functions = getFunctions(app);
  console.log("MarginPro: Firebase initialized with Local Persistence.");
} catch (error) {
  console.error("MarginPro: Firebase initialization failed:", error);
  // App will load but Firebase features will be disabled
}

export { auth, db, storage, functions };
export default app;
